import React from 'react';
import { Row, Spin } from 'antd';
import { CloseOutlined, LoadingOutlined } from '@ant-design/icons';
import PropTypes from 'prop-types';

export default function WorkflowMarketplaceLoadingContainer({
  onClose,
  workflow,
}) {
  if (!workflow) return null;
  const formattedComponents = workflow.components.map((component) => (
    <span className="workflow-marketplace-action-overlay-description-bold" key={component.name}>{component.name.toLowerCase()}, </span>
  ));
  return (
    <div className="workflow-marketplace-action-overlay">
      <Row>
        <Spin indicator={<LoadingOutlined />} />
        <div className="workflow-marketplace-action-overlay-title">Importing {workflow.name}</div>
        <CloseOutlined onClick={onClose} className="workflow-marketplace-action-overlay-close" />
        <div className="workflow-marketplace-action-overlay-description">
          This process includes adding&nbsp;
          {formattedComponents}
          <span className="workflow-marketplace-action-overlay-description-bold">automations, and other assets</span>.
          This may take a few minutes.
          We&apos;ll notify you once the import is complete.
        </div>
      </Row>
    </div>
  );
}

WorkflowMarketplaceLoadingContainer.propTypes = {
  onClose: PropTypes.func.isRequired,
  workflow: PropTypes.shape({
    components: PropTypes.arrayOf(PropTypes.shape({
      name: PropTypes.string.isRequired,
    })).isRequired,
  }).isRequired,
};
